import React from 'react';
import {Simulate} from "react-dom/test-utils";
import toggle = Simulate.toggle;
import {Emoji} from "../Store/Emoji";

interface UserSmileProps {
    setEmojiSheet: React.Dispatch<React.SetStateAction<boolean>>;
    guestEmojiId: number
}

const UserSmile: React.FC<UserSmileProps> = ({ setEmojiSheet,guestEmojiId }) =>{
    const toggleEmojiSheet = () => {
        setEmojiSheet(prev => !prev); // инвертируем значение
    };
    const guestSmile = Emoji.find(item => item.id === guestEmojiId)

     return (
        <div onClick={toggleEmojiSheet}>
            {guestSmile ? (
                <picture key={guestSmile.id}>
                    <source srcSet={guestSmile.source} type="image/webp" />
                    <img src={guestSmile.img} alt="😎" width="16" height="16" />
                </picture>
            ) : (
                <picture>
                    <source
                        srcSet="https://fonts.gstatic.com/s/e/notoemoji/latest/1f60e/512.webp"
                        type="image/webp"
                    />
                    <img
                        src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f60e/512.gif"
                        alt="😎"
                        width="16"
                        height="16"
                    />
                </picture>
            )}
        </div>
    )
}
export default UserSmile;
